import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useLocation, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import { Modal, Button } from "react-bootstrap";
import {
    combinarPacientesYEmpresas,
    filtrarPacientesParaModal,
    getNombreClienteFacturacion,
} from "../../../utils/busquedaPacienteFacturacion";
import "./ModalExitoFacturacion.css";

function CrearFacturaNoElectronica() {
    const location = useLocation();
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);

    // Estados del formulario
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [vencimiento, setVencimiento] = useState(new Date().toISOString().split('T')[0]);
    const [profesional, setProfesional] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    const [tipoPago, setTipoPago] = useState('contado');

    // Estados para datos de API
    const [profesionales, setProfesionales] = useState([]);

    // Estados del paciente
    const [pacienteId, setPacienteId] = useState('');
    const [nombrePaciente, setNombrePaciente] = useState('');
    const [tipoPaciente, setTipoPaciente] = useState('CC');
    const [documentoPaciente, setDocumentoPaciente] = useState('');

    // Estados de productos
    const [productos, setProductos] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState('');
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalDescuento, setTotalDescuento] = useState(0);
    const [totalAjuste, setTotalAjuste] = useState(0);
    const [totalIVA, setTotalIVA] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);

    // Funciones de cálculo con ajuste (misma lógica que presupuestos)
    const calcularBaseConDescuentoItem = (item) => {
        const precio = parseFloat(item.precio) || 0;
        const cantidad = parseFloat(item.cantidad) || 0;
        const porcentaje = parseFloat(item.porcentaje) || 0;
        const precioBase = precio * cantidad;
        const descuento = precioBase * (porcentaje / 100);
        return precioBase - descuento;
    };

    const calcularBaseAjustadaItem = (item) => {
        const baseConDescuento = calcularBaseConDescuentoItem(item);
        const ajuste = parseFloat(item.ajuste) || 0;
        return baseConDescuento + ajuste;
    };

    const calcularTotalItem = (item) => {
        const baseAjustada = calcularBaseAjustadaItem(item);
        const impuestoPct = parseFloat(item.impuesto) || 0;
        const impuesto = baseAjustada * (impuestoPct / 100);
        return baseAjustada + impuesto;
    };

    // Estados para lista de precios
    const [listaPrecios, setListaPrecios] = useState([]);
    const [clasificacionFiltro, setClasificacionFiltro] = useState('');
    const [buscarServicio, setBuscarServicio] = useState('');
    const [mostrarOpcionesServicio, setMostrarOpcionesServicio] = useState(false);
    const [especialidades, setEspecialidades] = useState([]);
    const [impuestos, setImpuestos] = useState([]);

    const [observaciones, setObservaciones] = useState('');
    const [showModalPaciente, setShowModalPaciente] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const pacientesPorPagina = 10;

    // Estados para modal de éxito
    const [showModalExito, setShowModalExito] = useState(false);
    const [numeroFacturaCreada, setNumeroFacturaCreada] = useState('');
    const [facturaIdCreada, setFacturaIdCreada] = useState(null);
    const [origenNavegacion, setOrigenNavegacion] = useState(null); // 'presupuesto' | 'factura' | null
    const [pacienteIdParaCartera, setPacienteIdParaCartera] = useState(null);

    // Estados para presupuesto activo
    const [presupuestoActivo, setPresupuestoActivo] = useState(null);
    const [presupuestosActivos, setPresupuestosActivos] = useState([]);
    const [saldoDisponible, setSaldoDisponible] = useState(0);
    const [copiarItemsPresupuesto, setCopiarItemsPresupuesto] = useState(false);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a crear facturas no electrónicas
        const tienePermiso = userdata.up && userdata.up.includes('facturacion');

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Verificar si viene un presupuesto o paciente en la URL
        const searchParams = new URLSearchParams(location.search);
        const presupuestoId = searchParams.get('presupuesto');
        const presupuestoActivoId = searchParams.get('presupuesto_activo');
        const pacienteIdUrl = searchParams.get('paciente_id');

        if (presupuestoActivoId) {
            setOrigenNavegacion('presupuesto');
            cargarPresupuestoActivoDesdeUrl(presupuestoActivoId, config);
        } else if (presupuestoId) {
            cargarPresupuesto(presupuestoId);
        } else if (pacienteIdUrl) {
            cargarDatosPacienteDesdeUrl(pacienteIdUrl, config);
        }

        // Cargar profesionales
        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes y empresas (tipo_cliente=1) para facturación
        Promise.all([
            axios.get('/pacientes', { ...config, params: { uid: userdata.user_id } }),
            axios.get('/pacientes', { ...config, params: { uid: userdata.user_id, solo_empresas: true } })
        ])
            .then(([respPacientes, respEmpresas]) => {
                setPacientes(combinarPacientesYEmpresas(respPacientes, respEmpresas));
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar especialidades
        axios.get('/especialidades-referencia?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar lista de precios
        axios.get('/lista-precios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setListaPrecios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar impuestos (tabla maestra - sin filtro por client_id)
        axios.get('/administrador-impuestos', config)
            .then(response => {
                if (response.status === 200) {
                    setImpuestos(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);

    const getClasificacionesDinamicas = () => {
        const clasificaciones = Array.from(
            new Set(
                listaPrecios
                    .map(item => (item.clasificacion || '').trim())
                    .filter(Boolean)
            )
        );
        return clasificaciones.sort((a, b) => a.localeCompare(b));
    };

    const getListaPreciosFiltrada = () => {
        let filtrada = listaPrecios;

        if (clasificacionFiltro) {
            filtrada = filtrada.filter(item => item.clasificacion === clasificacionFiltro);
        }

        if (buscarServicio.trim()) {
            const term = buscarServicio.toLowerCase();
            filtrada = filtrada.filter(item =>
                (item.nombre || '').toLowerCase().includes(term) ||
                (item.codigo || '').toLowerCase().includes(term)
            );
        }

        return filtrada;
    };

    const agregarServicio = () => {
        const servicio = listaPrecios.find(s => s.id == productoSeleccionado);
        if (servicio) {
            const nuevoProducto = {
                id: Date.now(),
                id_listadeprecios: servicio.id,
                codigo: servicio.codigo,
                clasificacion: servicio.clasificacion || '',
                servicio: servicio.nombre,
                descripcion: '',
                cantidad: 1,
                precio: parseFloat(servicio.precio),
                porcentaje: 0,
                impuesto: 0,
                ajuste: 0,
                total: parseFloat(servicio.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setProductoSeleccionado('');
            setBuscarServicio('');
            setMostrarOpcionesServicio(false);
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarTextoProducto = (id, campo, valor) => {
        const texto = String(valor ?? '').slice(0, 120);
        setProductos(productos.map((p) => (p.id === id ? { ...p, [campo]: texto } : p)));
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                if (campo === 'ajuste') {
                    // Permite escritura temporal de "-" en el input sin forzar 0
                    const productoActualizado = { ...p, ajuste: String(valor ?? '') };
                    const ajusteNumerico = parseFloat(productoActualizado.ajuste);
                    const baseConDescuento = calcularBaseConDescuentoItem(productoActualizado);
                    const baseBruta = (parseFloat(productoActualizado.precio) || 0) * (parseFloat(productoActualizado.cantidad) || 1);
                    const ajusteMinimo = -baseConDescuento; // No puede dejar el total en negativo
                    const ajusteMaximo = baseBruta; // No puede ser mayor al precio unitario x cantidad
                    if (Number.isFinite(ajusteNumerico)) {
                        if (ajusteNumerico < ajusteMinimo) {
                            productoActualizado.ajuste = ajusteMinimo;
                        } else if (ajusteNumerico > ajusteMaximo) {
                            productoActualizado.ajuste = ajusteMaximo;
                        }
                    }
                    productoActualizado.total = calcularTotalItem(productoActualizado);
                    return productoActualizado;
                }
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                productoActualizado.total = calcularTotalItem(productoActualizado);
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let subtotal = 0;
        let totalDescuentos = 0;
        let totalAjustes = 0;
        let totalImpuestos = 0;
        let total = 0;

        productosArray.forEach(producto => {
            const precioBase = producto.precio * producto.cantidad;
            const descuento = precioBase * (producto.porcentaje / 100);
            const ajuste = parseFloat(producto.ajuste) || 0;
            const baseConDescuento = precioBase - descuento;
            const baseAjustada = baseConDescuento + ajuste;
            const impuesto = baseAjustada * (producto.impuesto / 100);

            subtotal += precioBase;
            totalDescuentos += descuento;
            totalAjustes += ajuste;
            totalImpuestos += impuesto;
            total += parseFloat(producto.total ?? (baseAjustada + impuesto)) || 0;
        });

        setTotalBruto(subtotal);
        setTotalDescuento(totalDescuentos);
        setTotalAjuste(totalAjustes);
        setTotalIVA(totalImpuestos);
        setTotalPagar(total);
    };

    const getNombreCliente = getNombreClienteFacturacion;

    const getPacientesFiltrados = () =>
        filtrarPacientesParaModal(pacientes, busquedaPaciente);

    const getPacientesPaginados = () => {
        const pacientesFiltrados = getPacientesFiltrados();
        if (pacientesFiltrados.length === 0) return [];
        const totalPag = Math.ceil(pacientesFiltrados.length / pacientesPorPagina);
        const page = Math.min(Math.max(1, paginaActual), totalPag);
        const inicio = (page - 1) * pacientesPorPagina;
        return pacientesFiltrados.slice(inicio, inicio + pacientesPorPagina);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getPacientesFiltrados().length / pacientesPorPagina);
    };

    useEffect(() => {
        setPaginaActual(1);
    }, [busquedaPaciente]);

    useEffect(() => {
        if (showModalPaciente) {
            setPaginaActual(1);
        }
    }, [showModalPaciente]);

    const seleccionarPaciente = (paciente) => {
        const nombreCompleto = getNombreCliente(paciente);
        setPacienteId(paciente.id);
        setNombrePaciente(nombreCompleto);
        setTipoPaciente(paciente.tipo_documento || 'CC');
        setDocumentoPaciente(paciente.numero_documento || '');
        setShowModalPaciente(false);

        // Limpiar presupuesto activo anterior y cargar los del nuevo paciente
        setPresupuestoActivo(null);
        setSaldoDisponible(0);
        setCopiarItemsPresupuesto(false);
        cargarPresupuestosActivos(paciente.id);
    };

    // Funciones para modal de éxito
    const handleShowModalExito = () => setShowModalExito(true);
    const handleCloseModalExito = () => {
        setShowModalExito(false);
        // Opcional: redirigir al listado de facturas
        // history.push('/listado-facturas');
    };

    const cargarPresupuesto = async (presupuestoId) => {
        try {
            // Cargar datos del presupuesto - usar la misma URL que funciona en CrearFactura
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const response = await axios.get(`/presupuesto/${presupuestoId}?uid=${userdata.user_id}`);

            if (response.status === 200 && response.data) {
                const presupuesto = response.data;

                // El ID del paciente viene del presupuesto
                const pacienteId = presupuesto.paciente_id;
                setPacienteId(pacienteId);
                setProfesional(presupuesto.users_id.toString());

                // Cargar datos del paciente para mostrar nombre y documento
                const pacienteResponse = await axios.get(`/paciente?uid=${userdata.user_id}&id=${presupuesto.paciente_id}`);
                if (pacienteResponse.data && pacienteResponse.data.length > 0) {
                    const paciente = pacienteResponse.data[0];
                    const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
                    setNombrePaciente(nombreCompleto);
                    setTipoPaciente(paciente.tipo_documento || 'CC');
                    setDocumentoPaciente(paciente.numero_documento || '');
                }

                // Cargar detalle del presupuesto - usar la misma lógica que CrearFactura
                if (presupuesto.detalle) {
                    const productosPresupuesto = presupuesto.detalle.map(mapDetallePresupuestoAProductoFactura);

                    setProductos(productosPresupuesto);
                    calcularTotales(productosPresupuesto);
                }

                if (presupuesto.observaciones) {
                    setObservaciones(presupuesto.observaciones);
                }
            }
        } catch (error) {
            console.log('Error cargando presupuesto:', error);
            alert('Error al cargar el presupuesto: ' + (error.response?.data?.message || error.message));
        }
    };

    // Cargar presupuestos activos de un paciente
    const cargarPresupuestosActivos = async (pacienteIdParam) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };
        try {
            const response = await axios.get(`/presupuestos/paciente/${pacienteIdParam}/activos?uid=${userdata.user_id}`, config);
            if (response.status === 200) {
                setPresupuestosActivos(response.data.presupuestos || []);
            }
        } catch (error) {
            console.error('Error al cargar presupuestos activos:', error);
            setPresupuestosActivos([]);
        }
    };

    // Precargar presupuesto activo desde URL param (navegación desde EditarPresupuesto)
    const cargarPresupuestoActivoDesdeUrl = async (presupuestoActivoId, configParam) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = configParam || {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };
        try {
            const response = await axios.get(`/presupuesto/${presupuestoActivoId}?uid=${userdata.user_id}`, config);
            const presupuestoData = response.data;

            if (presupuestoData && presupuestoData.paciente_id) {
                // Cargar datos del paciente
                const pacienteResponse = await axios.get(`/paciente?uid=${userdata.user_id}&id=${presupuestoData.paciente_id}`, config);
                if (pacienteResponse.data && pacienteResponse.data.length > 0) {
                    const paciente = pacienteResponse.data[0];
                    const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
                    setPacienteId(presupuestoData.paciente_id);
                    setNombrePaciente(nombreCompleto);
                    setTipoPaciente(paciente.tipo_documento || 'CC');
                    setDocumentoPaciente(paciente.numero_documento || '');
                }

                // Cargar presupuestos activos del paciente
                await cargarPresupuestosActivos(presupuestoData.paciente_id);

                // Seleccionar automáticamente el presupuesto activo
                if (presupuestoData.estado === 1) {
                    setPresupuestoActivo(presupuestoData);
                    setSaldoDisponible(parseFloat(presupuestoData.saldo_disponible) || 0);
                    // Precargar profesional del presupuesto
                    if (presupuestoData.users_id) {
                        setProfesional(presupuestoData.users_id.toString());
                    }
                    // Guardar paciente para cartera
                    setPacienteIdParaCartera(presupuestoData.paciente_id);
                }
            }
        } catch (error) {
            console.error('Error al cargar presupuesto activo desde URL:', error);
        }
    };

    // Cargar datos del paciente desde URL param (navegación desde EstadoCuentaPaciente)
    const cargarDatosPacienteDesdeUrl = async (pacienteIdParam, configParam) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = configParam || {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };
        try {
            const pacienteResponse = await axios.get(`/paciente?uid=${userdata.user_id}&id=${pacienteIdParam}`, config);
            if (pacienteResponse.data && pacienteResponse.data.length > 0) {
                const paciente = pacienteResponse.data[0];
                const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
                setPacienteId(pacienteIdParam);
                setNombrePaciente(nombreCompleto);
                setTipoPaciente(paciente.tipo_documento || 'CC');
                setDocumentoPaciente(paciente.numero_documento || '');
                setPacienteIdParaCartera(pacienteIdParam);
                
                // Cargar presupuestos activos del paciente
                await cargarPresupuestosActivos(pacienteIdParam);
            }
        } catch (error) {
            console.error('Error al cargar datos del paciente desde URL:', error);
        }
    };

    // Manejar selección de presupuesto activo del dropdown
    const handleSeleccionPresupuestoActivo = async (e) => {
        const selectedId = e.target.value;
        if (!selectedId) {
            setPresupuestoActivo(null);
            setSaldoDisponible(0);
            setCopiarItemsPresupuesto(false);
            return;
        }

        const selected = presupuestosActivos.find(p => p.id == selectedId);
        if (selected) {
            setPresupuestoActivo(selected);
            setSaldoDisponible(parseFloat(selected.saldo_disponible) || 0);
            setCopiarItemsPresupuesto(false);
        }
    };

    const mapDetallePresupuestoAProductoFactura = (item) => {
        const cantidad = parseFloat(item.cantidad) || 1;
        const precioOriginal = parseFloat(item.precio_unitario) || 0;
        const porcentaje = parseFloat(item.porcentaje) || 0;
        const impuesto = parseFloat(item.impuesto) || 0;
        const ajuste = parseFloat(item.ajuste) || 0;
        const factorDescuento = 1 - (porcentaje / 100);
        const totalPresupuesto = parseFloat(item.total) || 0;
        const factorImpuesto = 1 + (impuesto / 100);

        let precioAjustado = precioOriginal;
        // Para facturación: conservar el total y el IVA del presupuesto (base ajustada antes de IVA).
        // Se despeja la base desde el total guardado y luego se obtiene un precio unitario equivalente.
        // Si hay ajuste, primero restamos el efecto del ajuste antes de despejar el precio.
        if (cantidad > 0 && factorDescuento > 0 && factorImpuesto > 0) {
            const baseConAjuste = totalPresupuesto / factorImpuesto;
            const baseSinAjuste = baseConAjuste - ajuste;
            precioAjustado = baseSinAjuste / (cantidad * factorDescuento);
        }

        if (!Number.isFinite(precioAjustado)) {
            precioAjustado = precioOriginal;
        }

        const precioBase = precioAjustado * cantidad;
        const descuentoValor = precioBase * (porcentaje / 100);
        const baseConDescuento = precioBase - descuentoValor;
        const baseAjustada = baseConDescuento + ajuste;
        const impuestoValor = baseAjustada * (impuesto / 100);

        return {
            id: Date.now() + Math.random(),
            id_listadeprecios: item.id_listadeprecios,
            codigo: item.lista_precio?.codigo || item.codigo || '',
            clasificacion: item.lista_precio?.clasificacion || '',
            servicio: item.lista_precio?.nombre || item.nombre || '',
            descripcion: item.descripcion || '',
            cantidad,
            precio: precioAjustado,
            porcentaje,
            impuesto,
            ajuste,
            total: baseAjustada + impuestoValor
        };
    };

    // Copiar ítems del presupuesto activo seleccionado
    const copiarItemsDePresupuesto = async () => {
        if (!presupuestoActivo) return;

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };
        try {
            const response = await axios.get(`/presupuesto/${presupuestoActivo.id}?uid=${userdata.user_id}`, config);
            const presupuestoData = response.data;

            if (presupuestoData && presupuestoData.detalle) {
                const productosPresupuesto = presupuestoData.detalle.map(mapDetallePresupuestoAProductoFactura);

                setProductos(productosPresupuesto);
                calcularTotales(productosPresupuesto);
                setCopiarItemsPresupuesto(true);
            }
        } catch (error) {
            console.error('Error al copiar ítems del presupuesto:', error);
            alert('Error al cargar los ítems del presupuesto');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!pacienteId || !profesional || productos.length === 0) {
            alert('Por favor complete todos los campos requeridos y agregue al menos un producto');
            return;
        }

        // Validar saldo si hay presupuesto activo seleccionado
        if (presupuestoActivo && totalPagar > saldoDisponible) {
            alert(`El valor de la factura (${parseFloat(totalPagar).toLocaleString('es-CO', {minimumFractionDigits: 2})}) excede el saldo pendiente del presupuesto (${parseFloat(saldoDisponible).toLocaleString('es-CO', {minimumFractionDigits: 2})})`);
            return;
        }

        const facturaData = {
            users_id: parseInt(profesional),
            paciente_id: parseInt(pacienteId),
            fecha_emision: fecha,
            fecha_vence: vencimiento,
            forma_pago: metodoPago,
            tipo_pago: tipoPago,
            valor_bruto: totalBruto,
            valor_total: totalPagar,
            observaciones: observaciones,
            presupuesto_id: presupuestoActivo ? parseInt(presupuestoActivo.id) : null,
            detalle: productos.map(p => ({
                id_listadeprecios: p.id_listadeprecios,
                descripcion: (p.descripcion || '').trim() || null,
                cantidad: p.cantidad,
                precio_unitario: p.precio,
                porcentaje: p.porcentaje,
                impuesto: p.impuesto,
                ajuste: parseFloat(p.ajuste) || 0,
                total: p.total
            }))
        };

        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const config = {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                }
            };

            const response = await axios.post('/factura-no-electronica', facturaData, config);

            if (response.status === 201) {
                const facturaId = response.data.factura_id;
                const numeroFactura = response.data.numero_factura || 'N/A';

                if (tipoPago === 'credito') {
                    // Crear registro en cuentas por cobrar para facturas a crédito
                    const cuentaData = {
                        factura_id: facturaId,
                        valor_total: totalPagar,
                        valor_pagado: 0,
                        valor_pendiente: totalPagar,
                        fecha_vencimiento: vencimiento
                    };

                    try {
                        await axios.post('/cuentas-por-cobrar', cuentaData, config);
                    } catch (error) {
                        console.log('Error creando cuenta por cobrar:', error);
                    }
                }

                // Guardar datos de la factura creada
                setNumeroFacturaCreada(numeroFactura);
                setFacturaIdCreada(facturaId);
                // Guardar paciente para cartera (antes de limpiar)
                setPacienteIdParaCartera(pacienteId || pacienteIdParaCartera);

                // Limpiar formulario
                setProductos([]);
                setPacienteId('');
                setNombrePaciente('');
                setDocumentoPaciente('');
                setObservaciones('');
                setTotalBruto(0);
                setTotalDescuento(0);
                setTotalIVA(0);
                setTotalPagar(0);
                setPresupuestoActivo(null);
                setPresupuestosActivos([]);
                setSaldoDisponible(0);
                setCopiarItemsPresupuesto(false);

                // Mostrar modal de éxito
                setTimeout(() => { handleShowModalExito() }, 500);
            }
        } catch (error) {
            console.log('Error completo:', error);
            alert('Error al guardar la factura: ' + (error.response?.data?.message || error.message));
        }
    };

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition factura-page">
                <style>{`
                    .factura-page { font-size: 12.5px; }
                    .factura-page .content-header h1 {
                        font-size: 1.9rem !important;
                        font-weight: 800 !important;
                        margin-bottom: 0 !important;
                    }
                    .factura-page label {
                        font-size: 0.76rem;
                        font-weight: 700;
                        color: #6c757d;
                        margin-bottom: 6px;
                        text-transform: uppercase;
                        letter-spacing: .03rem;
                    }
                    .factura-page .form-control {
                        font-size: 0.82rem !important;
                        padding: 0.38rem 0.68rem !important;
                        min-height: 36px;
                    }
                    .factura-page .btn { font-size: 0.82rem !important; }
                    .factura-soft-card {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.05) !important;
                        box-shadow: 0 10px 24px rgba(0,0,0,0.04) !important;
                    }
                    .factura-soft-header {
                        background: #fff;
                        border-bottom: 1px solid rgba(0,0,0,0.06);
                    }
                    .factura-main-title {
                        margin: 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 1rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .factura-main-title .title-icon {
                        width: 28px;
                        height: 28px;
                        border-radius: 9px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(23,162,184,0.1);
                        color: #17a2b8;
                        font-size: 0.85rem;
                    }
                    .factura-section-title {
                        margin: 0 0 14px 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 0.95rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .factura-section-title .title-icon {
                        width: 26px;
                        height: 26px;
                        border-radius: 8px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(50,58,69,0.08);
                        color: #323a45;
                        font-size: 0.78rem;
                    }
                    .factura-soft-banner {
                        border-radius: 14px;
                        border: 1px solid rgba(23,162,184,0.20);
                        background: linear-gradient(135deg, rgba(23,162,184,0.08) 0%, rgba(50,58,69,0.04) 100%);
                        padding: 10px 12px;
                        font-weight: 700;
                        color: #323a45;
                    }
                    .factura-soft-alert {
                        border-radius: 12px;
                        border: 1px solid rgba(220,53,69,0.2);
                        background: rgba(220,53,69,0.08);
                        color: #8a2d2d;
                    }
                    .chip-row {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                    }
                    .chip-filter {
                        border: 1px solid rgba(23,162,184,0.25);
                        background: rgba(23,162,184,0.06);
                        color: #17a2b8;
                        border-radius: 999px;
                        padding: 5px 12px;
                        font-size: 0.75rem;
                        font-weight: 700;
                        cursor: pointer;
                    }
                    .chip-filter.active {
                        background: #17a2b8;
                        color: #fff;
                        border-color: #17a2b8;
                    }
                    /* Modal éxito / paciente — mismo criterio que listados (cabecera suave, cuerpo con scroll) */
                    .cf-ne-exito-dialog {
                        max-width: 480px;
                    }
                    .cf-ne-exito-content {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.08) !important;
                        box-shadow: 0 12px 32px rgba(0,0,0,0.1) !important;
                        overflow: hidden;
                    }
                    .cf-ne-exito-head.modal-header {
                        background: #f8f9fa !important;
                        border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                    }
                    .cf-ne-exito-head .modal-title {
                        font-size: 1rem;
                        font-weight: 700;
                        color: #323a45;
                    }
                    .cf-ne-alert-success-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(40, 167, 69, 0.32);
                        background: rgba(40, 167, 69, 0.09);
                        color: #155724;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                        text-align: left;
                    }
                    .cf-ne-alert-info-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(23, 162, 184, 0.28);
                        background: rgba(23, 162, 184, 0.09);
                        color: #0c5460;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                        text-align: left;
                    }
                    .cf-ne-modal-paciente .modal-dialog {
                        max-height: calc(100vh - 1rem);
                        margin: 0.5rem auto;
                    }
                    .cf-ne-modal-paciente .modal-content {
                        max-height: calc(100vh - 1rem);
                        display: flex;
                        flex-direction: column;
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.08) !important;
                        box-shadow: 0 12px 32px rgba(0,0,0,0.1) !important;
                        overflow: hidden;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-head {
                        background: #f8f9fa !important;
                        border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-head .modal-title {
                        font-size: 1rem;
                        font-weight: 700;
                        color: #323a45;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-head .close {
                        color: #323a45;
                        opacity: 0.65;
                        text-shadow: none;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-body {
                        display: flex;
                        flex-direction: column;
                        min-height: 0;
                        flex: 1 1 auto;
                        overflow: hidden;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-table-wrap {
                        overflow-y: scroll;
                        scrollbar-gutter: stable;
                        -webkit-overflow-scrolling: touch;
                        flex: 1 1 auto;
                        min-height: 0;
                        height: min(52vh, 420px);
                        border-radius: 10px;
                        background: #fff;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-table-wrap table {
                        margin-bottom: 0;
                        font-size: 0.82rem;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-table-wrap thead th {
                        position: sticky;
                        top: 0;
                        z-index: 1;
                        background: #f8f9fa;
                        color: #7d7d7d;
                        font-size: 0.68rem;
                        font-weight: 700;
                        text-transform: uppercase;
                        border-bottom: 1px solid #e9ecef;
                    }
                    .cf-ne-paciente-pag {
                        flex-shrink: 0;
                    }
                    .factura-presupuesto-row {
                        align-items: flex-end;
                    }
                    .factura-saldo-wrap {
                        min-height: 38px;
                    }
                    .factura-saldo-wrap .factura-soft-banner {
                        width: 100%;
                        min-height: 38px;
                        margin-bottom: 0;
                        display: flex !important;
                        align-items: center;
                        padding: 8px 12px;
                    }
                    .factura-lineas-table .factura-col-accion-head,
                    .factura-lineas-table .factura-col-accion-body {
                        width: 44px;
                        min-width: 44px;
                        max-width: 44px;
                        padding: 6px 4px !important;
                        text-align: center;
                        vertical-align: middle !important;
                        white-space: nowrap;
                    }
                    .factura-total-label-cell {
                        border: none !important;
                        text-align: right;
                        vertical-align: middle !important;
                        padding: 3px 8px !important;
                        font-size: 0.72rem;
                        font-weight: 400;
                        color: #6c757d;
                        white-space: nowrap;
                        min-width: 96px;
                        line-height: 1.25;
                    }
                    .factura-total-value-cell {
                        border: none !important;
                        padding: 3px 0 !important;
                        vertical-align: middle !important;
                    }
                    .factura-total-value-input {
                        width: 100%;
                        max-width: 100%;
                        text-align: right;
                        font-size: 0.72rem;
                        font-weight: 400;
                        color: #495057;
                        background-color: #f8f9fa !important;
                        padding: 0.25rem 0.35rem !important;
                        min-height: 28px !important;
                    }
                    .factura-total-value-input.factura-total-final {
                        font-size: 0.75rem;
                        font-weight: 600;
                        color: #17a2b8;
                    }
                    .factura-lineas-table {
                        table-layout: fixed;
                        border-collapse: collapse;
                        font-size: 0.75rem;
                    }
                    .factura-lineas-table th,
                    .factura-lineas-table td {
                        border: none !important;
                    }
                    .factura-lineas-table thead th {
                        border-bottom: 1px solid #dee2e6 !important;
                        padding-bottom: 8px;
                        font-size: 0.7rem;
                        font-weight: 600;
                        color: #6c757d;
                    }
                    .factura-lineas-table tfoot tr:first-child td {
                        border-top: 1px solid #e9ecef !important;
                        padding-top: 10px;
                    }
                    .factura-lineas-table .factura-col-servicio,
                    .factura-lineas-table .factura-col-descripcion {
                        text-align: center;
                        vertical-align: top;
                        font-size: 0.72rem;
                        padding: 6px 8px;
                        line-height: 1.3;
                        word-break: break-word;
                    }
                    .factura-lineas-table .factura-input-descripcion {
                        width: 100% !important;
                        min-width: 0 !important;
                        min-height: 30px !important;
                        max-height: 4.5rem;
                        padding: 0.25rem 0.35rem !important;
                        font-size: 0.72rem !important;
                        line-height: 1.3;
                        resize: none;
                        overflow-wrap: anywhere;
                        word-break: break-word;
                        white-space: pre-wrap;
                    }
                    .factura-lineas-table .factura-col-cant,
                    .factura-lineas-table .factura-col-desc {
                        width: 72px;
                        max-width: 72px;
                    }
                    .factura-lineas-table .factura-col-precio {
                        width: 118px;
                        max-width: 118px;
                    }
                    .factura-lineas-table .factura-input-cant,
                    .factura-lineas-table .factura-input-desc {
                        width: 100% !important;
                        max-width: 64px !important;
                        min-width: 0 !important;
                        min-height: 32px !important;
                        padding: 0.28rem 0.35rem !important;
                        margin: 0 auto;
                        text-align: center;
                        -moz-appearance: textfield;
                    }
                    .factura-lineas-table .factura-input-precio {
                        width: 100% !important;
                        max-width: 110px !important;
                        min-height: 32px !important;
                        padding: 0.28rem 0.4rem !important;
                        text-align: right;
                        -moz-appearance: textfield;
                    }
                    .factura-lineas-table .factura-input-cant::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-cant::-webkit-inner-spin-button,
                    .factura-lineas-table .factura-input-desc::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-desc::-webkit-inner-spin-button,
                    .factura-lineas-table .factura-input-precio::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-precio::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item"><Link to="/listado-facturas">Listado de Facturas</Link></li>
                                        <li className="breadcrumb-item active">Crear Factura No Electrónica</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Crear Factura No Electrónica</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">

                            <div className="card card-info card-outline factura-soft-card">
                                <div className="card card-info-outline">
                                    <div className="card-header factura-soft-header">
                                        <h5 className="factura-main-title">
                                            <span className="title-icon"><i className="fas fa-file-invoice"></i></span>
                                            Información de la Factura
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>

                                            <h5 className="factura-section-title">
                                                <span className="title-icon"><i className="fas fa-user"></i></span>
                                                Información del Paciente
                                            </h5>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Nombre *</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={nombrePaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo *</label>
                                                        <select
                                                            className="form-control"
                                                            value={tipoPaciente}
                                                            readOnly
                                                            required
                                                        >
                                                            <option value="CC">CC</option>
                                                            <option value="CE">CE</option>
                                                            <option value="PA">PA</option>
                                                            <option value="PE">PE</option>
                                                            <option value="RC">RC</option>
                                                            <option value="TI">TI</option>
                                                            <option value="NIT">NIT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Documento *</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={documentoPaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="form-group">
                                                        <label>&nbsp;</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-info form-control"
                                                            onClick={() => setShowModalPaciente(true)}
                                                            disabled={origenNavegacion === 'presupuesto'}
                                                            title={origenNavegacion === 'presupuesto' ? 'El paciente viene del presupuesto y no puede cambiarse' : ''}
                                                        >
                                                            <i className="fas fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            {/* Sección Presupuesto Activo */}
                                            {pacienteId && presupuestosActivos.length > 0 && (
                                                <div className="card card-outline card-success mb-3">
                                                    <div className="card-header py-2">
                                                        <h6 className="mb-0"><i className="fas fa-wallet mr-1"></i> <b>Presupuesto Activo</b></h6>
                                                    </div>
                                                    <div className="card-body py-2">
                                                        <div className="row factura-presupuesto-row">
                                                            <div className="col-md-6">
                                                                <div className="form-group mb-2">
                                                                    <label>Seleccionar Presupuesto Activo</label>
                                                                    <select 
                                                                        className="form-control"
                                                                        value={presupuestoActivo ? presupuestoActivo.id : ''}
                                                                        onChange={handleSeleccionPresupuestoActivo}
                                                                    >
                                                                        <option value="">-- Sin presupuesto --</option>
                                                                        {presupuestosActivos.map(p => (
                                                                            <option key={p.id} value={p.id}>
                                                                                #{p.numero_presupuesto || p.id} - Pendiente: ${parseFloat(p.saldo_disponible || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                {presupuestoActivo && (
                                                                    <div className="form-group mb-2">
                                                                        <label>Saldo pendiente</label>
                                                                        <div className="factura-saldo-wrap">
                                                                            <span className="factura-soft-banner d-inline-flex align-items-center">
                                                                                <i className="fas fa-money-bill-wave mr-1"></i>
                                                                                Saldo Pendiente: ${parseFloat(saldoDisponible || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {presupuestoActivo && (
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    {!copiarItemsPresupuesto ? (
                                                                        <button 
                                                                            type="button" 
                                                                            className="btn btn-outline-success btn-sm"
                                                                            onClick={copiarItemsDePresupuesto}
                                                                        >
                                                                            <i className="fas fa-copy mr-1"></i> Copiar ítems del presupuesto
                                                                        </button>
                                                                    ) : (
                                                                        <span className="text-success">
                                                                            <i className="fas fa-check-circle mr-1"></i> Ítems copiados del presupuesto
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {/* Validación en tiempo real: total excede saldo */}
                                                        {presupuestoActivo && totalPagar > saldoDisponible && (
                                                            <div className="row mt-2">
                                                                <div className="col-md-12">
                                                                    <div className="alert mb-0 py-2 factura-soft-alert">
                                                                        <i className="fas fa-exclamation-triangle mr-1"></i>
                                                                        El valor total de la factura (${parseFloat(totalPagar || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})}) excede el saldo pendiente (${parseFloat(saldoDisponible || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})})
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            <hr />

                                            <h5 className="factura-section-title">
                                                <span className="title-icon"><i className="fas fa-receipt"></i></span>
                                                Datos de Factura
                                            </h5>

                                            <div className="row">
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Fecha*</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={fecha}
                                                            onChange={(e) => {
                                                                setFecha(e.target.value);
                                                                if (tipoPago === 'contado') {
                                                                    setVencimiento(e.target.value);
                                                                }
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo de Pago *</label>
                                                        <select
                                                            className="form-control"
                                                            value={tipoPago}
                                                            onChange={(e) => {
                                                                setTipoPago(e.target.value);
                                                                if (e.target.value === 'contado') {
                                                                    setVencimiento(fecha);
                                                                }
                                                            }}
                                                            required
                                                        >
                                                            <option value="contado">Contado</option>
                                                            <option value="credito">Crédito</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Vencimiento *</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={vencimiento}
                                                            onChange={(e) => setVencimiento(e.target.value)}
                                                            disabled={tipoPago === 'contado'}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Profesional *</label>
                                                        <select
                                                            className="form-control"
                                                            value={profesional}
                                                            onChange={(e) => setProfesional(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {profesionales.map(prof => (
                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Método de Pago *</label>
                                                        <select
                                                            className="form-control"
                                                            value={metodoPago}
                                                            onChange={(e) => setMetodoPago(e.target.value)}
                                                            required
                                                        >
                                                            <option value="10">Efectivo</option>
                                                            <option value="42">Consignación bancaria</option>
                                                            <option value="1">Instrumento no definido</option>
                                                            <option value="20">Cheque</option>
                                                            <option value="30">Transferencia Crédito</option>
                                                            <option value="31">Transferencia Débito</option>
                                                            <option value="45">Transferencia Crédito Bancario</option>
                                                            <option value="47">Transferencia Débito Bancaria</option>
                                                            <option value="48">Tarjeta Crédito</option>
                                                            <option value="49">Tarjeta Débito</option>
                                                            <option value="ZZZ">Acuerdo mutuo</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                {/* Primera fila: Clasificación dinámica */}
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <label>Clasificación</label>
                                                        <div className="chip-row mb-2">
                                                            <button
                                                                type="button"
                                                                className={`chip-filter ${clasificacionFiltro === '' ? 'active' : ''}`}
                                                                onClick={() => setClasificacionFiltro('')}
                                                            >
                                                                Todas
                                                            </button>
                                                            {getClasificacionesDinamicas().map((clas) => (
                                                                <button
                                                                    key={clas}
                                                                    type="button"
                                                                    className={`chip-filter ${clasificacionFiltro === clas ? 'active' : ''}`}
                                                                    onClick={() => setClasificacionFiltro(clas)}
                                                                >
                                                                    {clas}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                {/* Segunda fila: Selector con búsqueda integrada + Botón */}
                                                <div className="row mt-2">
                                                    <div className="col-md-10">
                                                        <label>Selecciona el Servicio a Facturar</label>
                                                        <div style={{ position: 'relative' }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Buscar y seleccionar servicio (código o nombre)..."
                                                                value={buscarServicio}
                                                                onFocus={() => setMostrarOpcionesServicio(true)}
                                                                onBlur={() => setTimeout(() => setMostrarOpcionesServicio(false), 150)}
                                                                onChange={(e) => {
                                                                    setBuscarServicio(e.target.value);
                                                                    setProductoSeleccionado('');
                                                                    setMostrarOpcionesServicio(true);
                                                                }}
                                                            />

                                                            {mostrarOpcionesServicio && (
                                                                <div
                                                                    className="shadow-sm"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        zIndex: 1000,
                                                                        width: '100%',
                                                                        maxHeight: '260px',
                                                                        overflowY: 'auto',
                                                                        background: '#fff',
                                                                        border: '1px solid #dee2e6',
                                                                        borderRadius: '10px',
                                                                        marginTop: '4px'
                                                                    }}
                                                                >
                                                                    {getListaPreciosFiltrada().length === 0 ? (
                                                                        <div style={{ padding: '10px 12px', color: '#8c8c8c', fontSize: '0.85rem' }}>
                                                                            No hay servicios para tu búsqueda.
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {getListaPreciosFiltrada().slice(0, 30).map(item => (
                                                                                <button
                                                                                    key={item.id}
                                                                                    type="button"
                                                                                    onMouseDown={() => {
                                                                                        setProductoSeleccionado(item.id);
                                                                                        setBuscarServicio(`${item.codigo || ''} - ${item.nombre || ''}`.trim());
                                                                                        setMostrarOpcionesServicio(false);
                                                                                    }}
                                                                                    style={{
                                                                                        display: 'block',
                                                                                        width: '100%',
                                                                                        textAlign: 'left',
                                                                                        border: 'none',
                                                                                        background: 'transparent',
                                                                                        padding: '8px 12px',
                                                                                        borderBottom: '1px solid #f3f3f3',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                >
                                                                                    <span style={{ fontWeight: 600, color: '#323a45' }}>{item.codigo}</span>
                                                                                    <span style={{ color: '#8c8c8c' }}> - {item.nombre}</span>
                                                                                </button>
                                                                            ))}
                                                                            {getListaPreciosFiltrada().length > 30 && (
                                                                                <div style={{ padding: '8px 12px', color: '#8c8c8c', fontSize: '0.75rem', background: '#fafafa', borderTop: '1px solid #f0f0f0' }}>
                                                                                    Mostrando 30 de {getListaPreciosFiltrada().length} resultados. Escribe más para refinar.
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label>&nbsp;</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-info btn-block"
                                                            onClick={agregarServicio}
                                                            disabled={!productoSeleccionado}
                                                        >
                                                            Agregar Servicio
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {productos.length > 0 && (
                                                <div className="table-responsive">
                                                    <table className="table factura-lineas-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center" style={{ width: '10%' }}>Clasificación</th>
                                                                <th className="text-center factura-col-servicio">Servicio</th>
                                                                <th className="text-center factura-col-descripcion">Descripción</th>
                                                                <th className="text-center factura-col-cant">Cant.</th>
                                                                <th className="text-center factura-col-precio">Precio</th>
                                                                <th className="text-center factura-col-desc">Desc %</th>
                                                                <th className="text-center" style={{ width: '9%', minWidth: '88px' }}>Ajuste</th>
                                                                <th className="text-center" style={{ width: '9%' }}>Impuesto</th>
                                                                <th className="text-center" style={{ width: '15%' }}>Total</th>
                                                                <th className="text-center factura-col-accion-head"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {productos.map(producto => (
                                                                <tr key={producto.id}>
                                                                    <td>{producto.clasificacion || 'N/A'}</td>
                                                                    <td className="factura-col-servicio">{producto.servicio}</td>
                                                                    <td className="factura-col-descripcion">
                                                                        <textarea
                                                                            rows={2}
                                                                            className="form-control form-control-sm factura-input-descripcion"
                                                                            value={producto.descripcion || ''}
                                                                            maxLength={120}
                                                                            onChange={(e) => actualizarTextoProducto(producto.id, 'descripcion', e.target.value)}
                                                                        />
                                                                    </td>
                                                                    <td className="text-center factura-col-cant">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm factura-input-cant"
                                                                            value={producto.cantidad}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                            min="1"
                                                                            max="999"
                                                                        />
                                                                    </td>
                                                                    <td className="text-right factura-col-precio">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm factura-input-precio"
                                                                            value={producto.precio}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                            step="0.01"
                                                                        />
                                                                    </td>
                                                                    <td className="text-center factura-col-desc">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm factura-input-desc"
                                                                            value={producto.porcentaje}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                            min="0"
                                                                            max="100"
                                                                            step="0.01"
                                                                        />
                                                                    </td>
                                                                    <td className="text-right">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={producto.ajuste ?? ''}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'ajuste', e.target.value)}
                                                                            style={{ textAlign: 'right' }}
                                                                            min={-calcularBaseConDescuentoItem(producto)}
                                                                            max={(parseFloat(producto.precio) || 0) * (parseFloat(producto.cantidad) || 1)}
                                                                        />
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={producto.impuesto}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                            step="0.01"
                                                                            style={{ textAlign: 'center' }}
                                                                        />
                                                                    </td>
                                                                    <td className="text-right">$ {parseFloat(producto.total || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                                    <td className="factura-col-accion-body">
                                                                        <button
                                                                            type="button"
                                                                            className="btn p-0 border-0 bg-transparent text-danger"
                                                                            onClick={() => eliminarProducto(producto.id)}
                                                                            title="Eliminar servicio"
                                                                        >
                                                                            <i className="fas fa-trash-alt"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                         </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan="7" style={{border: 'none'}}></td>
                                                                <td className="factura-total-label-cell">Subtotal:</td>
                                                                <td className="factura-total-value-cell">
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control form-control-sm factura-total-value-input" 
                                                                        value={'$ ' + parseFloat(totalBruto || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td style={{border: 'none'}}></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="7" style={{border: 'none'}}></td>
                                                                <td className="factura-total-label-cell">Descuento{'\u00A0'}:</td>
                                                                <td className="factura-total-value-cell">
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control form-control-sm factura-total-value-input" 
                                                                        value={'$ ' + parseFloat(totalDescuento || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td style={{border: 'none'}}></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="7" style={{border: 'none'}}></td>
                                                                <td className="factura-total-label-cell">Ajuste:</td>
                                                                <td className="factura-total-value-cell">
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control form-control-sm factura-total-value-input" 
                                                                        value={'$ ' + productos.reduce((sum, p) => sum + (parseFloat(p.ajuste) || 0), 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td style={{border: 'none'}}></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="7" style={{border: 'none'}}></td>
                                                                <td className="factura-total-label-cell">IVA:</td>
                                                                <td className="factura-total-value-cell">
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control form-control-sm factura-total-value-input" 
                                                                        value={'$ ' + parseFloat(totalIVA || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td style={{border: 'none'}}></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="7" style={{border: 'none'}}></td>
                                                                <td className="factura-total-label-cell">Total:</td>
                                                                <td className="factura-total-value-cell">
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control form-control-sm factura-total-value-input factura-total-final" 
                                                                        value={'$ ' + parseFloat(totalPagar || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td style={{border: 'none'}}></td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            )}

                                            <hr />

                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={observaciones}
                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                    placeholder="Observaciones adicionales"
                                                />
                                            </div>

                                            <div className="form-group">
                                                <button type="submit" className="btn btn-success" disabled={presupuestoActivo && totalPagar > saldoDisponible}>
                                                    <i className="fas fa-save"></i> Guardar Factura
                                                </button>
                                                <Link to="/listado-facturas" className="btn btn-secondary ml-2">
                                                    <i className="fas fa-times"></i> Cancelar
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                {/* Modal de Éxito */}
                <Modal
                    show={showModalExito}
                    onHide={handleCloseModalExito}
                    centered
                    dialogClassName="mx-exito-dialog"
                    contentClassName="mx-exito-content"
                >
                    <Modal.Header closeButton className="mx-exito-head">
                        <Modal.Title>
                            <span className="mx-exito-head-icon">
                                <i className="fas fa-check"></i>
                            </span>
                            Factura guardada
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="mx-exito-body">
                        <div className="mx-exito-hero" aria-hidden="true">
                            <i className="fas fa-check"></i>
                        </div>
                        <h5 className="mx-exito-title">Factura guardada exitosamente</h5>
                        <p className="mx-exito-label mb-0">Número de Factura:</p>
                        <div className="mx-exito-numero">{numeroFacturaCreada || '—'}</div>
                    </Modal.Body>

                    <Modal.Footer className="mx-exito-footer">
                        <Button
                            className="mx-exito-btn-outline mx-exito-btn-outline--teal"
                            onClick={() => {
                                handleCloseModalExito();
                                const url = `${window.location.origin}/#/informacion-factura/${facturaIdCreada}`;
                                window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
                            }}
                        >
                            <i className="fas fa-eye mr-2"></i> Ver factura
                        </Button>
                        {pacienteIdParaCartera && (
                            <Button
                                className="mx-exito-btn-outline mx-exito-btn-outline--teal"
                                onClick={() => {
                                    handleCloseModalExito();
                                    history.push(`/estado-cuenta-paciente/${pacienteIdParaCartera}`);
                                }}
                            >
                                <i className="fas fa-wallet mr-2"></i> Cartera
                            </Button>
                        )}
                        <Button
                            className="mx-exito-btn-outline mx-exito-btn-outline--gray"
                            onClick={() => {
                                handleCloseModalExito();
                                if (origenNavegacion === 'presupuesto') {
                                    history.push('/listado-presupuestos');
                                } else {
                                    history.push('/listado-facturas');
                                }
                            }}
                        >
                            <i className="fas fa-arrow-left mr-2"></i>
                            Volver
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Footer showToast={false} delay={0} />

                {/* Modal de selección de paciente — scroll en tabla + paginación visible */}
                {showModalPaciente && (() => {
                    const pacientesFiltradosLista = getPacientesFiltrados();
                    const totalPacientesLista = pacientesFiltradosLista.length;
                    const totalPaginasLista = getTotalPaginas();
                    const paginaLista = totalPaginasLista > 0 ? Math.min(Math.max(1, paginaActual), totalPaginasLista) : 1;
                    const idxInicio = totalPacientesLista === 0 ? 0 : (paginaLista - 1) * pacientesPorPagina + 1;
                    const idxFin = Math.min(paginaLista * pacientesPorPagina, totalPacientesLista);
                    return (
                        <div className="modal fade show cf-ne-modal-paciente" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1055, overflowY: 'auto' }} tabIndex="-1" role="dialog">
                            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                <div className="modal-content border-0">
                                    <div className="modal-header cf-ne-paciente-head">
                                        <h5 className="modal-title mb-0">
                                            <i className="fas fa-user-injured mr-2 text-info"></i>
                                            Seleccionar paciente
                                        </h5>
                                        <button
                                            type="button"
                                            className="close"
                                            onClick={() => setShowModalPaciente(false)}
                                            aria-label="Cerrar"
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body cf-ne-paciente-body">
                                        <div className="form-group mb-3">
                                            <label className="mb-1 d-block small font-weight-bold text-muted">Buscar</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Buscar por nombre o documento"
                                                value={busquedaPaciente}
                                                onChange={(e) => setBusquedaPaciente(e.target.value)}
                                                autoFocus
                                            />
                                        </div>
                                        <div className="cf-ne-paciente-table-wrap table-responsive">
                                            <table className="table table-hover table-sm table-borderless mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Nombre</th>
                                                        <th>Documento</th>
                                                        <th className="text-center" style={{ width: 56 }}>Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {totalPacientesLista === 0 ? (
                                                        <tr>
                                                            <td colSpan="3" className="text-center text-muted py-4">
                                                                No hay pacientes que coincidan con la búsqueda.
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        getPacientesPaginados().map((paciente) => (
                                                            <tr key={paciente.id}>
                                                                <td>
                                                                    {getNombreCliente(paciente)}
                                                                </td>
                                                                <td>{paciente.numero_documento}</td>
                                                                <td className="text-center align-middle">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-success"
                                                                        title="Seleccionar paciente"
                                                                        aria-label="Seleccionar paciente"
                                                                        onClick={() => seleccionarPaciente(paciente)}
                                                                    >
                                                                        <i className="fas fa-check"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="cf-ne-paciente-pag d-flex flex-wrap align-items-center justify-content-between gap-2 pt-3 mt-2 border-top">
                                            <small className="text-muted mb-0">
                                                {totalPacientesLista === 0
                                                    ? '0 pacientes'
                                                    : `Mostrando ${idxInicio}–${idxFin} de ${totalPacientesLista}`}
                                            </small>
                                            {totalPaginasLista > 1 && (
                                                <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary"
                                                        disabled={paginaLista <= 1}
                                                        onClick={() => setPaginaActual((p) => Math.max(1, p - 1))}
                                                    >
                                                        « Anterior
                                                    </button>
                                                    <span className="small font-weight-bold text-secondary px-1">
                                                        {paginaLista} / {totalPaginasLista}
                                                    </span>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary"
                                                        disabled={paginaLista >= totalPaginasLista}
                                                        onClick={() => setPaginaActual((p) => Math.min(totalPaginasLista, p + 1))}
                                                    >
                                                        Siguiente »
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })()}
            </div>
        );
    } else {
        return <Loading />;
    }
}

export default CrearFacturaNoElectronica;